export default [
  {
    disableBeacon: true,
    target: "#tour-marketplace",
    title: "Access tons of compliance resources, tools and training material",
    content: "The marketplace is your hub for affordable resources to support your journey to compliance.",
    placement: "bottom"
  }
]


// WEBPACK FOOTER //
// ./src/components/tour/e-commerce/steps.js